/** An amount on the wire: `amount` in MINOR units of `currency`. */
export interface ILedgerMoney {
    amount: number;
    currency: string;
}

/** The posting's amount in another currency and its rate (base amount ÷ foreign amount). */
export interface ILedgerForeign {
    amount: ILedgerMoney;
    rate: number;
}

export interface ILedgerRowWire {
    id: string;
    /** ISO `YYYY-MM-DD`. */
    date: string;
    description: string | null;
    contraAccountNumber: string;
    contraAccountName: string | null;
    side: 'DEBIT' | 'CREDIT';
    amount: ILedgerMoney;
    /** Running balance in the base currency, debit positive. */
    balance: ILedgerMoney;
    foreign: ILedgerForeign | null;
    /** Running balance in the account currency — foreign-currency accounts only. */
    foreignBalance: ILedgerMoney | null;
    /** The ERP's VAT code of the posting, as the ERP shows it; null where it ties none to the line. */
    vatCode: string | null;
}

export interface ILedgerBalanceWire {
    base: ILedgerMoney;
    /** Null on a base-currency account, and where the ERP did not deliver the account-currency figure. */
    foreign: ILedgerMoney | null;
}

/** `GET projects/:projectId/accounts/:accountId/ledger` — one page of the Kontenblatt. */
export interface IAccountLedgerPage {
    accountId: string;
    accountNumber: string;
    baseCurrency: string | null;
    /** The account's own currency when it differs from the closing's. */
    foreignCurrency: string | null;
    period: { periodStart: string; periodEnd: string } | null;
    opening: ILedgerBalanceWire | null;
    /** After the LAST posting of the period, on every page. */
    closing: ILedgerBalanceWire | null;
    rows: ILedgerRowWire[];
    totalCount: number;
    nextCursor: string | null;
}
